import * as moment from "moment";

export const destinations = [
//    {name: "Disneyland® Resort", code: "Disneyland Resort"},
    {name: "Walt Disney World® Resort", code: "Walt Disney World Resort"}
];

export function destinationLabel(dest: string): string {
    const d = destinations.find(d => d.code === dest);
    return d ? d.name : dest;
}

export interface HotelListingAvailability {
    listing: Hotel;
    availability?: RoomAvailability;
}

export interface Hotel {
    id: string;
    title: string;
    destination: string;
    detailUrl?: string;
    subtitle?: string;
    distanceToResort?: string;
    thumbnailImageUrl?: string;
    packageRate?: number;
    detail?: HotelDetail;
    description?: string;
}

export interface HotelDetail {
    rooms: Room[];
    photos: Image[];
    amenities: string[];
    roomAvailability: {[roomId: string]: RoomAvailability[]};
}

export interface RoomAvailability {
    offer: string;
    roomId: string;
    hotelId: string;
    availabilityId: string;
    checkIn: string;
    checkOut: string;
    hotelRate: number;
    days: number;
    numAdults: number;
    numChildren: number;
}

export interface Room {
    id: string;
    title: string;
    description: string;
    bedding: string;
    occupancy: string;
    amenities: string[];
    photos: Image[];
    packageRate: number;
    roomRate: number;
    disneyPick: boolean;
    thumbnailImageUrl: string;
}

export interface Image {
    id: string;
    url: string;
    thumbnailUrl: string;
    title: string;
    alt: string;
}

interface SearchCommon {
    destination: string;
    numAdults: number;
    childAges: number[];
    numRooms: number;
    includeTickets: boolean;
    hotelName?: string;
}

export interface Search extends SearchCommon {
    checkIn: moment.Moment;
    checkOut: moment.Moment;
}

export interface SearchResponse extends SearchCommon {
    checkIn: string;
    checkOut: string;
}

export function convertSearchResponse(response: SearchResponse): Search {
    return {
        ...response,
        checkIn: moment(response.checkIn),
        checkOut: moment(response.checkOut)
    } as Search;
}

export interface Ticket {
    id?: string;
    name: string;
    destination: string;
    adultPrice: number;
    childPrice: number;
    days: number;
    validRange: number;
    active: boolean;
    createdOn?: string;
}

export const defaultTicket = () => ({
    name: "",
    destination: destinations[0].code,
    adultPrice: 0,
    childPrice: 0,
    days: 3,
    validRange: 5,
    active: true
} as Ticket);



// WEBPACK FOOTER //
// ./src/models/hotels.ts